import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CUSTOMER_FEATURE_KEY,
  State,
  customerAdapter
} from './customer.reducer';
import * as fromAppointment from '../appointment/appointment.reducer';
import { CustomerEntity } from './customer.models';

// Lookup the 'Customer' feature state managed by NgRx
export const getCustomerState =
  createFeatureSelector<State>(CUSTOMER_FEATURE_KEY);

const { selectAll, selectEntities } = customerAdapter.getSelectors();

export const getCustomersLoading = createSelector(
  getCustomerState,
  (state: State) => state.loading
);

export const getCustomerSaving = createSelector(
  getCustomerState,
  (state: State) => state.saving
);

export const getCustomersError = createSelector(
  getCustomerState,
  (state: State) => state.error
);

export const getAllCustomer = createSelector(getCustomerState, (state: State) =>
  selectAll(state)
);

export const getCustomerEntities = createSelector(
  getCustomerState,
  (state: State) => selectEntities(state)
);

export const selectCreateDrawer = createSelector(
  getCustomerState,
  (state: State) => state.createDrawer
);

export const selectCurrentCustomerId = createSelector(
  getCustomerState,
  (state: State) => state.selectedId
);

export const selectSelectedCustomerResources = createSelector(
  getCustomerState,
  (state: State) => state.selectedCustomerResources
);

export const selectCurrentCustomer = createSelector(
  getCustomerEntities,
  selectCurrentCustomerId,
  (entities, customerId) => (customerId ? entities[customerId] : null)
);

export const getCustomerActivities = createSelector(
  selectCurrentCustomer,
  (customer: CustomerEntity) => ({
    activities: customer.activities || [],
    isLoading: customer.isActivitiesLoading,
    error: customer.activitiesError,
    hasMore: customer.hasMoreActivities
  })
);

export const getCustomerResources = createSelector(
  getCustomerState,
  (state: State) => state.selectedCustomerResources
);

export const getPaymentMethods = createSelector(
  selectCurrentCustomer,
  (customer: CustomerEntity) => customer?.paymentMethods || []
);

export const getPaymentMethodsLoading = createSelector(
  getCustomerState,
  (state: State) => state.paymentMethodLoading
);

/* -------------------------------------------------------------------------- */
/*                       Customer Appointments Selectors                      */
/* -------------------------------------------------------------------------- */

const { selectAll: selectAllAppointments } =
  fromAppointment.appointmentAdapter.getSelectors();

export const getCustomerAppointmentsState = createSelector(
  getCustomerResources,
  state => state.appointments
);

export const getCustomerAppointments = createSelector(
  getCustomerAppointmentsState,
  (state: fromAppointment.State) => selectAllAppointments(state)
);

export const getCustomerAppointmentsLoading = createSelector(
  getCustomerAppointmentsState,
  (state: fromAppointment.State) => state.loading
);

export const selectSelectedCustomerCredit = createSelector(
  selectCurrentCustomer,
  customer => customer?.credit
);
